// English → Simplified Chinese translations for countries, states/provinces, and cities
// Used by ProfileForm, Profiles listing, Directory, Register, AdminProfiles, etc.

export const countryZh = {
  'United States': '美国',
  'Canada': '加拿大',
  'United Kingdom': '英国',
  'Australia': '澳大利亚',
  'China': '中国',
  'Taiwan': '台湾',
  'Japan': '日本',
  'South Korea': '韩国',
  'Singapore': '新加坡',
  'Malaysia': '马来西亚',
  'Germany': '德国',
  'France': '法国',
  'Italy': '意大利',
  'Spain': '西班牙',
  'Brazil': '巴西',
  'Mexico': '墨西哥',
  'India': '印度',
  'Thailand': '泰国',
  'Vietnam': '越南',
  'Philippines': '菲律宾',
  'Indonesia': '印度尼西亚',
  'New Zealand': '新西兰',
  'South Africa': '南非',
  'United Arab Emirates': '阿联酋',
  'Israel': '以色列',
  'Netherlands': '荷兰',
  'Sweden': '瑞典',
  'Switzerland': '瑞士',
  'Portugal': '葡萄牙',
  'Ireland': '爱尔兰',
  'Russia': '俄罗斯'
};

export const stateZh = {
  // United States
  'Alabama': '阿拉巴马州', 'Alaska': '阿拉斯加州', 'Arizona': '亚利桑那州', 'Arkansas': '阿肯色州',
  'California': '加利福尼亚州', 'Colorado': '科罗拉多州', 'Connecticut': '康涅狄格州', 'Delaware': '特拉华州',
  'Florida': '佛罗里达州', 'Georgia': '佐治亚州', 'Hawaii': '夏威夷州', 'Idaho': '爱达荷州',
  'Illinois': '伊利诺伊州', 'Indiana': '印第安纳州', 'Iowa': '爱荷华州', 'Kansas': '堪萨斯州',
  'Kentucky': '肯塔基州', 'Louisiana': '路易斯安那州', 'Maine': '缅因州', 'Maryland': '马里兰州',
  'Massachusetts': '马萨诸塞州', 'Michigan': '密歇根州', 'Minnesota': '明尼苏达州', 'Mississippi': '密西西比州',
  'Missouri': '密苏里州', 'Montana': '蒙大拿州', 'Nebraska': '内布拉斯加州', 'Nevada': '内华达州',
  'New Hampshire': '新罕布什尔州', 'New Jersey': '新泽西州', 'New Mexico': '新墨西哥州', 'New York': '纽约州',
  'North Carolina': '北卡罗来纳州', 'North Dakota': '北达科他州', 'Ohio': '俄亥俄州', 'Oklahoma': '俄克拉荷马州',
  'Oregon': '俄勒冈州', 'Pennsylvania': '宾夕法尼亚州', 'Rhode Island': '罗德岛州', 'South Carolina': '南卡罗来纳州',
  'South Dakota': '南达科他州', 'Tennessee': '田纳西州', 'Texas': '德克萨斯州', 'Utah': '犹他州',
  'Vermont': '佛蒙特州', 'Virginia': '弗吉尼亚州', 'Washington': '华盛顿州', 'West Virginia': '西弗吉尼亚州',
  'Wisconsin': '威斯康星州', 'Wyoming': '怀俄明州', 'Washington DC': '华盛顿特区',
  // Canada
  'Alberta': '艾伯塔省', 'British Columbia': '不列颠哥伦比亚省', 'Manitoba': '马尼托巴省',
  'New Brunswick': '新不伦瑞克省', 'Newfoundland and Labrador': '纽芬兰与拉布拉多省', 'Nova Scotia': '新斯科舍省',
  'Ontario': '安大略省', 'Prince Edward Island': '爱德华王子岛省', 'Quebec': '魁北克省', 'Saskatchewan': '萨斯喀彻温省',
  // United Kingdom
  'England': '英格兰', 'Scotland': '苏格兰', 'Wales': '威尔士', 'Northern Ireland': '北爱尔兰',
  // Australia
  'New South Wales': '新南威尔士州', 'Victoria': '维多利亚州', 'Queensland': '昆士兰州',
  'Western Australia': '西澳大利亚州', 'South Australia': '南澳大利亚州', 'Tasmania': '塔斯马尼亚州',
  'Australian Capital Territory': '澳大利亚首都领地', 'Northern Territory': '北领地',
  // Japan
  'Tokyo': '东京都', 'Osaka': '大阪府', 'Kanagawa': '神奈川县', 'Aichi': '爱知县',
  'Hokkaido': '北海道', 'Kyoto': '京都府', 'Fukuoka': '福冈县',
  // South Korea
  'Seoul': '首尔', 'Busan': '釜山', 'Gyeonggi': '京畿道', 'Daegu': '大邱',
  // Singapore
  'Singapore': '新加坡',
  // Malaysia
  'Kuala Lumpur': '吉隆坡', 'Selangor': '雪兰莪州', 'Penang': '槟城州', 'Johor': '柔佛州',
  // Germany
  'Bavaria': '巴伐利亚州', 'Berlin': '柏林', 'Hamburg': '汉堡',
  'North Rhine-Westphalia': '北莱茵-威斯特法伦州', 'Hesse': '黑森州', 'Baden-Württemberg': '巴登-符腾堡州',
  // France
  'Île-de-France': '法兰西岛', "Provence-Alpes-Côte d'Azur": '普罗旺斯-阿尔卑斯-蓝色海岸',
  'Auvergne-Rhône-Alpes': '奥弗涅-罗纳-阿尔卑斯', 'Nouvelle-Aquitaine': '新阿基坦', 'Occitanie': '奥克西塔尼',
  // Italy
  'Lazio': '拉齐奥', 'Lombardy': '伦巴第', 'Veneto': '威尼托', 'Tuscany': '托斯卡纳', 'Campania': '坎帕尼亚',
  // Spain
  'Community of Madrid': '马德里自治区', 'Catalonia': '加泰罗尼亚', 'Andalusia': '安达卢西亚', 'Valencia': '瓦伦西亚',
  // Brazil
  'São Paulo': '圣保罗州', 'Rio de Janeiro': '里约热内卢州', 'Minas Gerais': '米纳斯吉拉斯州', 'Bahia': '巴伊亚州',
  // Mexico
  'Mexico City': '墨西哥城', 'Jalisco': '哈利斯科州', 'Nuevo León': '新莱昂州', 'Quintana Roo': '金塔纳罗奥州',
  // India
  'Maharashtra': '马哈拉施特拉邦', 'Delhi': '德里', 'Karnataka': '卡纳塔克邦',
  'Tamil Nadu': '泰米尔纳德邦', 'Telangana': '特伦甘纳邦', 'West Bengal': '西孟加拉邦',
  // Thailand
  'Bangkok': '曼谷', 'Chiang Mai': '清迈', 'Phuket': '普吉',
  // Vietnam
  'Ho Chi Minh City': '胡志明市', 'Hanoi': '河内', 'Da Nang': '岘港',
  // Philippines
  'Metro Manila': '马尼拉大都会', 'Cebu': '宿务',
  // Indonesia
  'Jakarta': '雅加达', 'Bali': '巴厘岛', 'East Java': '东爪哇',
  // New Zealand
  'Auckland': '奥克兰', 'Wellington': '惠灵顿', 'Canterbury': '坎特伯雷',
  // South Africa
  'Gauteng': '豪登省', 'Western Cape': '西开普省', 'KwaZulu-Natal': '夸祖鲁-纳塔尔省',
  // UAE
  'Dubai': '迪拜', 'Abu Dhabi': '阿布扎比', 'Sharjah': '沙迦',
  // Israel
  'Tel Aviv District': '特拉维夫区', 'Jerusalem District': '耶路撒冷区', 'Haifa District': '海法区',
  // Netherlands
  'North Holland': '北荷兰省', 'South Holland': '南荷兰省', 'Utrecht': '乌得勒支省',
  // Sweden
  'Stockholm': '斯德哥尔摩省', 'Västra Götaland': '西约塔兰省', 'Skåne': '斯科讷省',
  // Switzerland
  'Zurich': '苏黎世', 'Geneva': '日内瓦', 'Bern': '伯尔尼',
  // Portugal
  'Lisbon': '里斯本', 'Porto': '波尔图',
  // Ireland
  'Leinster': '伦斯特', 'Munster': '芒斯特',
  // Russia
  'Moscow': '莫斯科', 'Saint Petersburg': '圣彼得堡'
};

export const cityZh = {
  // United States
  'Birmingham': '伯明翰', 'Montgomery': '蒙哥马利', 'Huntsville': '亨茨维尔', 'Mobile': '莫比尔', 'Tuscaloosa': '塔斯卡卢萨',
  'Anchorage': '安克雷奇', 'Fairbanks': '费尔班克斯', 'Juneau': '朱诺',
  'Phoenix': '凤凰城', 'Tucson': '图森', 'Mesa': '梅萨', 'Scottsdale': '斯科茨代尔', 'Chandler': '钱德勒', 'Tempe': '坦佩',
  'Little Rock': '小石城', 'Fort Smith': '史密斯堡', 'Fayetteville': '费耶特维尔',
  'Los Angeles': '洛杉矶', 'San Francisco': '旧金山', 'San Diego': '圣地亚哥', 'San Jose': '圣何塞',
  'Sacramento': '萨克拉门托', 'Fresno': '弗雷斯诺', 'Oakland': '奥克兰', 'Irvine': '尔湾', 'Pasadena': '帕萨迪纳',
  'Long Beach': '长滩', 'Santa Monica': '圣莫尼卡', 'Beverly Hills': '比弗利山', 'Anaheim': '阿纳海姆', 'Riverside': '里弗赛德',
  'Denver': '丹佛', 'Colorado Springs': '科罗拉多斯普林斯', 'Aurora': '奥罗拉', 'Boulder': '博尔德', 'Fort Collins': '柯林斯堡',
  'Hartford': '哈特福德', 'New Haven': '纽黑文', 'Stamford': '斯坦福德', 'Bridgeport': '布里奇波特',
  'Wilmington': '威尔明顿', 'Dover': '多佛', 'Newark': '纽瓦克',
  'Miami': '迈阿密', 'Orlando': '奥兰多', 'Tampa': '坦帕', 'Jacksonville': '杰克逊维尔', 'Fort Lauderdale': '劳德代尔堡',
  'St. Petersburg': '圣彼得斯堡', 'Naples': '那不勒斯', 'West Palm Beach': '西棕榈滩',
  'Atlanta': '亚特兰大', 'Savannah': '萨凡纳', 'Augusta': '奥古斯塔', 'Athens': '雅典',
  'Honolulu': '火奴鲁鲁', 'Hilo': '希洛', 'Kailua': '凯卢阿',
  'Boise': '博伊西', 'Meridian': '梅里迪恩', 'Nampa': '南帕',
  'Chicago': '芝加哥', 'Naperville': '内珀维尔', 'Springfield': '斯普林菲尔德', 'Rockford': '罗克福德',
  'Indianapolis': '印第安纳波利斯', 'Fort Wayne': '韦恩堡', 'Evansville': '埃文斯维尔', 'South Bend': '南本德',
  'Des Moines': '得梅因', 'Cedar Rapids': '锡达拉皮兹', 'Iowa City': '爱荷华城',
  'Wichita': '威奇托', 'Overland Park': '奥弗兰帕克', 'Kansas City': '堪萨斯城', 'Topeka': '托皮卡',
  'Louisville': '路易斯维尔', 'Lexington': '列克星敦', 'Bowling Green': '博林格林',
  'New Orleans': '新奥尔良', 'Baton Rouge': '巴吞鲁日', 'Shreveport': '什里夫波特',
  'Portland': '波特兰', 'Bangor': '班戈',
  'Baltimore': '巴尔的摩', 'Bethesda': '贝塞斯达', 'Rockville': '罗克维尔', 'Annapolis': '安纳波利斯',
  'Boston': '波士顿', 'Cambridge': '剑桥', 'Worcester': '伍斯特',
  'Detroit': '底特律', 'Grand Rapids': '大急流城', 'Ann Arbor': '安阿伯', 'Lansing': '兰辛',
  'Minneapolis': '明尼阿波利斯', 'St. Paul': '圣保罗', 'Rochester': '罗切斯特', 'Duluth': '德卢斯',
  'Jackson': '杰克逊', 'Gulfport': '格尔夫波特', 'Biloxi': '比洛克西',
  'St. Louis': '圣路易斯', 'Columbia': '哥伦比亚',
  'Billings': '比林斯', 'Missoula': '米苏拉', 'Great Falls': '大瀑布城',
  'Omaha': '奥马哈', 'Lincoln': '林肯',
  'Las Vegas': '拉斯维加斯', 'Reno': '里诺', 'Henderson': '亨德森',
  'Manchester': '曼彻斯特', 'Nashua': '纳舒厄', 'Concord': '康科德',
  'Jersey City': '泽西市', 'Trenton': '特伦顿', 'Princeton': '普林斯顿', 'Hoboken': '霍博肯',
  'Albuquerque': '阿尔伯克基', 'Santa Fe': '圣塔菲', 'Las Cruces': '拉斯克鲁塞斯',
  'New York City': '纽约市', 'Buffalo': '布法罗', 'Albany': '奥尔巴尼', 'Syracuse': '锡拉丘兹',
  'Brooklyn': '布鲁克林', 'Queens': '皇后区', 'Manhattan': '曼哈顿',
  'Charlotte': '夏洛特', 'Raleigh': '罗利', 'Durham': '达勒姆', 'Greensboro': '格林斯伯勒', 'Asheville': '阿什维尔',
  'Fargo': '法戈', 'Bismarck': '俾斯麦', 'Grand Forks': '大福克斯',
  'Columbus': '哥伦布', 'Cleveland': '克利夫兰', 'Cincinnati': '辛辛那提', 'Toledo': '托莱多', 'Akron': '阿克伦',
  'Oklahoma City': '俄克拉荷马城', 'Tulsa': '塔尔萨', 'Norman': '诺曼',
  'Salem': '塞勒姆', 'Eugene': '尤金', 'Bend': '本德',
  'Philadelphia': '费城', 'Pittsburgh': '匹兹堡', 'Harrisburg': '哈里斯堡', 'Allentown': '艾伦敦',
  'Providence': '普罗维登斯', 'Warwick': '沃里克', 'Newport': '纽波特',
  'Charleston': '查尔斯顿', 'Greenville': '格林维尔', 'Myrtle Beach': '默特尔比奇',
  'Sioux Falls': '苏福尔斯', 'Rapid City': '拉皮德城',
  'Nashville': '纳什维尔', 'Memphis': '孟菲斯', 'Knoxville': '诺克斯维尔', 'Chattanooga': '查塔努加',
  'Houston': '休斯顿', 'Dallas': '达拉斯', 'Austin': '奥斯汀', 'San Antonio': '圣安东尼奥',
  'Fort Worth': '沃思堡', 'El Paso': '埃尔帕索', 'Plano': '普莱诺', 'Frisco': '弗里斯科',
  'Salt Lake City': '盐湖城', 'Provo': '普罗沃', 'Park City': '帕克城',
  'Burlington': '伯灵顿', 'Montpelier': '蒙彼利埃',
  'Virginia Beach': '弗吉尼亚海滩', 'Richmond': '里士满', 'Arlington': '阿灵顿', 'Alexandria': '亚历山大', 'Norfolk': '诺福克',
  'Seattle': '西雅图', 'Tacoma': '塔科马', 'Spokane': '斯波坎', 'Bellevue': '贝尔维尤', 'Olympia': '奥林匹亚',
  'Huntington': '亨廷顿', 'Morgantown': '摩根敦',
  'Milwaukee': '密尔沃基', 'Madison': '麦迪逊', 'Green Bay': '格林贝',
  'Cheyenne': '夏延', 'Casper': '卡斯珀',
  'Washington': '华盛顿',
  // Canada
  'Calgary': '卡尔加里', 'Edmonton': '埃德蒙顿', 'Red Deer': '红鹿市', 'Lethbridge': '莱斯布里奇',
  'Vancouver': '温哥华', 'Victoria': '维多利亚', 'Surrey': '素里', 'Burnaby': '本拿比', 'Kelowna': '基洛纳',
  'Winnipeg': '温尼伯', 'Brandon': '布兰登',
  'Fredericton': '弗雷德里克顿', 'Saint John': '圣约翰', 'Moncton': '蒙克顿',
  "St. John's": '圣约翰斯', 'Corner Brook': '科纳布鲁克',
  'Halifax': '哈利法克斯', 'Sydney': '悉尼', 'Dartmouth': '达特茅斯',
  'Toronto': '多伦多', 'Ottawa': '渥太华', 'Mississauga': '密西沙加', 'Hamilton': '汉密尔顿',
  'London': '伦敦', 'Brampton': '布兰普顿', 'Markham': '万锦市',
  'Charlottetown': '夏洛特敦',
  'Montreal': '蒙特利尔', 'Quebec City': '魁北克市', 'Laval': '拉瓦尔', 'Gatineau': '加蒂诺',
  'Saskatoon': '萨斯卡通', 'Regina': '里贾纳',
  // UK
  'Liverpool': '利物浦', 'Leeds': '利兹', 'Bristol': '布里斯托尔', 'Oxford': '牛津', 'Brighton': '布莱顿', 'Bath': '巴斯',
  'Edinburgh': '爱丁堡', 'Glasgow': '格拉斯哥', 'Aberdeen': '阿伯丁', 'Dundee': '邓迪',
  'Cardiff': '加的夫', 'Swansea': '斯旺西',
  'Belfast': '贝尔法斯特', 'Derry': '德里', 'Lisburn': '利斯本',
  // Australia
  'Newcastle': '纽卡斯尔', 'Wollongong': '卧龙岗',
  'Melbourne': '墨尔本', 'Geelong': '吉朗', 'Ballarat': '巴拉瑞特',
  'Brisbane': '布里斯班', 'Gold Coast': '黄金海岸', 'Cairns': '凯恩斯', 'Townsville': '汤斯维尔',
  'Perth': '珀斯', 'Fremantle': '弗里曼特尔',
  'Adelaide': '阿德莱德',
  'Hobart': '霍巴特', 'Launceston': '朗塞斯顿',
  'Canberra': '堪培拉',
  'Darwin': '达尔文', 'Alice Springs': '爱丽斯泉',
  // Japan
  'Shibuya': '涩谷', 'Shinjuku': '新宿', 'Minato': '港区',
  'Osaka': '大阪', 'Sakai': '堺市',
  'Yokohama': '横滨', 'Kawasaki': '川崎',
  'Nagoya': '名古屋',
  'Sapporo': '札幌',
  'Kyoto': '京都',
  'Fukuoka': '福冈',
  'Tokyo': '东京',
  // Korea
  'Seoul': '首尔', 'Busan': '釜山', 'Suwon': '水原', 'Incheon': '仁川', 'Seongnam': '城南', 'Daegu': '大邱',
  // Malaysia
  'Kuala Lumpur': '吉隆坡', 'Petaling Jaya': '八打灵再也', 'Shah Alam': '莎亚南', 'Subang Jaya': '梳邦再也',
  'George Town': '乔治市', 'Johor Bahru': '新山',
  // Germany
  'Munich': '慕尼黑', 'Nuremberg': '纽伦堡', 'Berlin': '柏林', 'Hamburg': '汉堡',
  'Cologne': '科隆', 'Düsseldorf': '杜塞尔多夫', 'Dortmund': '多特蒙德',
  'Frankfurt': '法兰克福', 'Wiesbaden': '威斯巴登',
  'Stuttgart': '斯图加特', 'Heidelberg': '海德堡',
  // France
  'Paris': '巴黎', 'Versailles': '凡尔赛',
  'Marseille': '马赛', 'Nice': '尼斯', 'Cannes': '戛纳',
  'Lyon': '里昂', 'Grenoble': '格勒诺布尔',
  'Bordeaux': '波尔多',
  'Toulouse': '图卢兹', 'Montpellier': '蒙彼利埃',
  // Italy
  'Rome': '罗马', 'Milan': '米兰', 'Venice': '威尼斯', 'Verona': '维罗纳',
  'Florence': '佛罗伦萨', 'Pisa': '比萨',
  // Spain
  'Madrid': '马德里', 'Barcelona': '巴塞罗那', 'Seville': '塞维利亚', 'Malaga': '马拉加', 'Granada': '格拉纳达',
  'Valencia': '瓦伦西亚',
  // Brazil
  'São Paulo': '圣保罗', 'Campinas': '坎皮纳斯', 'Rio de Janeiro': '里约热内卢', 'Belo Horizonte': '贝洛奥里藏特',
  'Salvador': '萨尔瓦多',
  // Mexico
  'Mexico City': '墨西哥城', 'Guadalajara': '瓜达拉哈拉', 'Monterrey': '蒙特雷', 'Cancún': '坎昆',
  // India
  'Mumbai': '孟买', 'Pune': '浦那', 'New Delhi': '新德里', 'Bangalore': '班加罗尔', 'Mysore': '迈索尔',
  'Chennai': '金奈', 'Hyderabad': '海得拉巴', 'Kolkata': '加尔各答',
  // Thailand
  'Bangkok': '曼谷', 'Chiang Mai': '清迈', 'Phuket': '普吉',
  // Vietnam
  'Ho Chi Minh City': '胡志明市', 'Hanoi': '河内', 'Da Nang': '岘港',
  // Philippines
  'Manila': '马尼拉', 'Quezon City': '奎松市', 'Makati': '马卡蒂', 'Cebu City': '宿务市',
  // Indonesia
  'Jakarta': '雅加达', 'Denpasar': '登巴萨', 'Ubud': '乌布', 'Surabaya': '泗水',
  // NZ
  'Auckland': '奥克兰', 'Wellington': '惠灵顿', 'Christchurch': '基督城',
  // SA
  'Johannesburg': '约翰内斯堡', 'Pretoria': '比勒陀利亚', 'Cape Town': '开普敦', 'Durban': '德班',
  // UAE
  'Dubai': '迪拜', 'Abu Dhabi': '阿布扎比', 'Sharjah': '沙迦',
  // Israel
  'Tel Aviv': '特拉维夫', 'Jerusalem': '耶路撒冷', 'Haifa': '海法',
  // Netherlands
  'Amsterdam': '阿姆斯特丹', 'Rotterdam': '鹿特丹', 'The Hague': '海牙', 'Utrecht': '乌得勒支',
  // Sweden
  'Stockholm': '斯德哥尔摩', 'Gothenburg': '哥德堡', 'Malmö': '马尔默',
  // Switzerland
  'Zurich': '苏黎世', 'Geneva': '日内瓦', 'Bern': '伯尔尼',
  // Portugal
  'Lisbon': '里斯本', 'Porto': '波尔图',
  // Ireland
  'Dublin': '都柏林', 'Cork': '科克', 'Limerick': '利默里克',
  // Russia
  'Moscow': '莫斯科', 'Saint Petersburg': '圣彼得堡'
};

// Single lookup map for any location name (country/state/city) → Chinese
const allLocationsZh = { ...countryZh, ...stateZh, ...cityZh };

/**
 * Translate a country/state/city name to Chinese.
 * - If language !== 'zh', returns the original.
 * - If translation missing, returns the original.
 * - Chinese-native names (e.g. '北京', '台北') pass through unchanged.
 */
export function translateLocation(name, language) {
  if (!name) return name;
  if (language !== 'zh') return name;
  return allLocationsZh[name] || name;
}

export default translateLocation;
